import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';
import { CompetitionSummaryComponent } from '../summary/competition-summary.component';
import {
  CompetitionBadgesComponent,
  CompetitionStatus,
} from '../badges/competition-badges.component';
import { CompetitionAttribute } from '../attribute';

@Component({
  selector: 'lib-web-competition-link',
  imports: [
    CommonModule,
    RouterLink,
    CompetitionSummaryComponent,
    CompetitionBadgesComponent,
    NgOptimizedImage,
  ],
  templateUrl: './competition-link.component.html',
  styleUrl: './competition-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompetitionLinkComponent {
  readonly name = input.required<string>();
  readonly status = input<CompetitionStatus | undefined>(undefined);
  readonly icon = input.required<string>();
  readonly link = input.required<string | unknown[]>();
  readonly progress = input<{ played: number; total: number } | undefined>(
    undefined,
  );
  readonly attributes = input<CompetitionAttribute[]>([]);
  readonly winner = input<string | undefined>(undefined);
  readonly runnerUp = input<string | undefined>(undefined);
}
